import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { competitiveColumns, competitiveRows, type Support } from '../../data/vendoo';
const LABEL: Record<Support, string> = {
  yes: 'Yes',
  partial: 'Partly',
  no: 'No'
};
function Cell({
  value
}: {
  value: Support;
}) {
  if (value === 'yes') {
    return <span className="inline-grid h-6 w-6 place-items-center rounded-full bg-ink-soft text-ink" aria-label={LABEL[value]} data-id="element-583" data-mp="mo0em8uwq22v">
        <CheckIcon className="h-3.5 w-3.5" strokeWidth={2.5} data-id="element-584" data-mp="7yug6n3w8fw1" />
      </span>;
  }
  if (value === 'partial') {
    return <span className="rounded-full bg-surface px-2 py-0.5 text-[11px] font-medium text-fg-muted" aria-label={LABEL[value]} data-id="element-585" data-mp="csq7x7tkd6ir">
        Partly
      </span>;
  }
  return <span className="inline-grid h-6 w-6 place-items-center text-fg-faint" aria-label={LABEL[value]} data-id="element-586" data-mp="31c5osa89slx">
      <MinusIcon className="h-3.5 w-3.5" data-id="element-587" data-mp="3l7gz3j680nm0" />
    </span>;
}
export function CompetitiveTable() {
  return <div className="overflow-x-auto rounded-2xl border border-line bg-white" data-id="element-588" data-mp="3q7uwm7a74f5s">
      <table className="w-full min-w-[560px] text-left text-sm" data-id="element-589" data-mp="2c2a8h612otlo">
        <thead data-id="element-590" data-mp="275jrmghg1tz7">
          <tr className="border-b border-line" data-id="element-591" data-mp="273yxgrz1kd1v">
            <th scope="col" className="px-5 py-4 text-xs font-medium text-fg-faint" data-id="element-592" data-mp="2l4jh1qcs6cwf">
              What sellers need
            </th>
            {competitiveColumns.map((col, i) => <th key={col} scope="col" className={`px-3 py-4 text-center text-xs font-semibold ${i === 0 ? 'text-ink' : 'text-fg-muted'}`} data-id="element-593" data-mp="2g3cd62drdxv1" data-mpi={i}>
                {col}
              </th>)}
          </tr>
        </thead>
        <tbody data-id="element-594" data-mp="226yuwr1ehsfi">
          {competitiveRows.map(row => {
          const isGap = row.values.every(v => v !== 'yes');
          return <tr key={row.feature} className={`border-b border-line last:border-b-0 ${isGap ? 'bg-coral-soft/50' : ''}`} data-id="element-595" data-mp="19ourqsc211sg">
                <th scope="row" className="px-5 py-3.5 font-medium text-fg" data-id="element-596" data-mp="14pi80gghcau3">
                  {row.feature}
                  {isGap && <span className="ml-2 text-[11px] font-semibold text-rust" data-id="element-597" data-mp="34s9cowafijiu">Gap</span>}
                </th>
                {row.values.map((value, i) => <td key={i} className="px-3 py-3.5 text-center" data-id="element-598" data-mp="3ei2mpsuxaqkz" data-mpi={i}>
                    <Cell value={value} data-id="element-599" data-mp="3jhfl9av5pm3e" />
                  </td>)}
              </tr>;
        })}
        </tbody>
      </table>
    </div>;
}